<template>
  <div class="ma-6">
    <!-- Exibindo dados atuais -->
    <div class="pa-6" v-if="row.deletedAt == null">
      Este teclado está atualmente
      <span class="tag green">ativo</span>.

      <br />

      <v-btn large color="error" class="mt-8" @click="doDeactivate">
        Desativar...
      </v-btn>
    </div>
    <div class="pa-6" v-else>
      Este teclado está
      <span class="tag red">inativo</span>
      desde
      <code>{{ row.deletedAt | moment('DD/MM/YYYY HH:mm') }}</code>.

      <br />

      <v-btn large color="success" class="mt-8" @click="doReactivate">
        Reativar...
      </v-btn>
    </div>
  </div>
</template>

<script>
import EditStore from './EditStore'

export default {
  tabTitle: 'Desativar',
  computed: {
    row() { return EditStore.row }
  },
  methods: {
    async doDeactivate() {
      let proceed = await this.$confirm({
        message: `Deseja desativar este teclado? <br/><br/> É possível reativá-lo depois.`,
        okColor: 'red',
        okText: 'Sim, desativar',
        cancelText: 'Não, cancelar'
      })

      if (proceed) {
        this.$rootLoading(async () => {
          await EditStore.deactivate()
          this.$snack('Registro desativado com sucesso')
          this.$emit('reload')
        })
      }
    },

    async doReactivate() {
      let proceed = await this.$confirm({
        message: `Deseja reativar este teclado?`,
        okColor: 'green',
        okText: 'Sim, reativar',
        cancelText: 'Não, cancelar'
      })

      if (proceed) {
        this.$rootLoading(async () => {
          await EditStore.reactivate(this.row.id)
          this.$snack('Registro reativado com sucesso')
          this.$emit('reload')
        })
      }
    }
  }
}
</script>

<style></style>
